import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { genericFetchData, uploadDocuments } from "../../../Services/Service";
import {
  HOSPITAL_CONTEXT,
  hospital_document,
  hospital_domestic_agreement,
  hospital_exterior_image,
  hospital_image,
  hospital_interior_image,
  hospital_international_agreement,
  hospital_logo,
} from "../../../Utils/AppConstance";
import { getUserRole } from "../../../Storage/Datastore";

export default function useHospitalAdd() {
  const navigate = useNavigate();
  const userRole = getUserRole();
  const [activeTab, setActiveTab] = useState(0);

  const [doc, setDoc] = useState({
    hospitalDoc: [],
    document: [],
    image: [],
    hospitalImage: [],
    documentIds: [],
  });

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const [details, setDetails] = useState({
    id: 0,
    name: "",
    platforms: [],
    location: {
      id: 0,
      name: "",
      country: null,
      state: null,
      approved: null,
    },
    address: null,
    contactNumber: null,
    alternateContactNumber: null,
    email: null,
    referralLink: null,
    about: null,
    mapLink: null,
    coordinates: null,
    locationId: 0,
    departmentIds: [0],
    topTreatmentIds: [0],
    departmentListResponse: {
      departments: [],
    },
    treatmentListBasicResponse: {
      treatmentsBasics: [],
    },
  });
  const [checkedItems, setCheckedItems] = useState({});
  const [checkedItemsId, setCheckedItemsId] = useState([]);
  const [treatments, setTreatments] = useState([]);
  const [locations, setLocations] = useState({});
  const [departments, setDepartments] = useState({});
  const [isEditable, setIsEditable] = useState(true);
  const [rejectedReason, setRejectedReason] = useState("");
  const [error, setError] = useState(false);
  const [isHospitalNameValid, setIsHospitalNameValid] = useState({
    isName: false,
    isLocation: false,
    isContact: false,
  });

  const location = useLocation();
  const isLive = location?.state?.isLive && location?.state?.isLive;
  const id = location?.state && location?.state?.id;
  const currentStatus = location?.state?.status && location?.state?.status;
  const taskId = location?.state?.taskId && location?.state?.taskId;
  const locationData = location?.state?.data && location?.state?.data;
  const locationDatas = location?.state && location?.state;
  const department =
    location?.state?.data?.department && location?.state?.data?.department;

  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });

  const handleClick = (newState) => {
    setState({ ...newState, open: true });
  };

  const items = [
    { id: 1, name: "List in Mykare" },
    { id: 2, name: "List in KareTrip" },
    { id: 3, name: "List in Karemitra" },
  ];

  const [interdoc, setInterDoc] = useState({
    agreementDoc: [],
    document: [],
    documentIds: [],
  });

  const [domDoc, setDomDoc] = useState({
    agreementDoc: [],
    document: [],
    documentIds: [],
  });
  const [logo, setLogo] = useState({
    agreementDoc: [],
    document: [],
    documentIds: [],
  });

  const [interiorImage, setInteriorImage] = useState({
    agreementDoc: [],
    document: [],
    documentIds: [],
  });

  const getDomDocuments = async (contextId) => {
    try {
      const response = await genericFetchData(
        `/document/all?contextId=${contextId}&context=${HOSPITAL_CONTEXT}&category=${hospital_domestic_agreement}`,
        "GET"
      );
      const status = response.status;
      const responseData = await response.json();
      if (status === 200) {
        setDomDoc((s) => ({ ...s, document: responseData }));
      } else {
        console.log("=======error", responseData);
      }
    } catch (error) {
      console.log("=======error", error);
    }
  };

  const handleDisapprove = async (status) => {
    // const ApproveDisapproveStatus = status;
    let department = locationData?.department;

    if (status === "REJECTED" && !rejectedReason) {
      console.log("Rejected reason is required for REJECTED status.");
      return;
    }
    let selectedDepartment = department ? department : 'OPERATIONS'

    const postData = {
  
     departmentApproved: { [selectedDepartment]: status },
      dataType: "CENTER",
      taskId: taskId,
      typeId: id,
      userRole: userRole,
      rejectedReason: rejectedReason,
    };
    try {
      const response = await genericFetchData(
        `/myspace/task/update`,
        "POST",
        postData
      );
      // const status = response.status;
      const responseData = await response.json();

      if (response.status === 200) {
        console.log(status, "status check");
        if (status === "REJECTED") navigate("/mySpace");
        else {
          navigate("/hospital");
        }
      }

      // if (status === 200) {
      //   setDomDoc((s) => ({ ...s, document: responseData }));
      // } else {
      //   console.log("=======error", responseData);
      // }
    } catch (error) {
      console.log("=======error", error);
    }
  };

  const saveDomDocuments = async (id) => {
    const data = {
      documents: domDoc.agreementDoc,
      context: HOSPITAL_CONTEXT,
      category: hospital_domestic_agreement,
      contextId: id,
    };
    try {
      const response = await uploadDocuments(data);
      if (response.status == 200) {
        getDomDocuments(id);
      }
    } catch (error) {
      console.log("error===============", error);
    }
  };

  const saveDocuments = async (id) => {
    const data = {
      documents: interdoc.agreementDoc,
      context: HOSPITAL_CONTEXT,
      category: hospital_international_agreement,
      contextId: id,
    };
    try {
      const response = await uploadDocuments(data);
      if (response.status == 200) {
        alert("Document saved successfully");
        getInterDocuments();
      }
    } catch (error) {
      console.log("error===============", error);
    }
  };

  const saveInteriorDocuments = async (id) => {
    const data = {
      documents: interiorImage.agreementDoc,
      context: HOSPITAL_CONTEXT,
      category: hospital_interior_image,
      contextId: id,
    };
    try {
      const response = await uploadDocuments(data);
      if (response.status == 200) {
        alert("Document saved successfully");
        getInteriorDocuments();
      }
    } catch (error) {
      console.log("error===============", error);
    }
  };

  const saveHospitalLogo = async (contextId) => {
    const data = {
      documents: logo.agreementDoc,
      context: HOSPITAL_CONTEXT,
      category: hospital_logo,
      contextId: contextId,
    };
    try {
      const response = await uploadDocuments(data);
      if (response.status == 200) {
        console.log("Document saved successfully");
      }
    } catch (error) {
      console.log("error===============", error);
    }
  };

  const getHospitalDetails = async (centerId) => {
    const response = await genericFetchData(`/center/${centerId}`, "GET");
    const responseData = await response.json();
    if (response.status == 200) {
      setDetails({
        ...responseData,
        coordinates:
          responseData.latitude &&
          responseData.latitude + "," + responseData.longitude,
      });
      const departments = Array.isArray(
        responseData?.departmentListResponse?.departments
      )
        ? responseData.departmentListResponse.departments
        : [];
      const departmentIds = departments.map((item) => item.id);
      if (departmentIds.length) {
        getTreatments(departmentIds);
      }
      const matchingData = responseData?.platforms?.map((item) => {
        setCheckedItems((prevCheckedItems) => ({
          ...prevCheckedItems,
          [item.id]: true,
        }));
      });
      setCheckedItems((prevCheckedItems) => ({
        ...prevCheckedItems,
        [0]: responseData.mykare,
      }));
      const ids = responseData?.platforms?.map((item) => item.id);
      if (responseData.mykare) {
        ids.push(0);
      }
      setCheckedItemsId(ids);
      setIsEditable(false);
    } else {
      console.log("=======error", responseData);
    }
  };

  const isShow = (() => {
    if (checkedItemsId.includes(2)) {
      if (checkedItemsId.length > 1) {
        return false;
      }
      return true;
    }
  })();

  const getTreatments = async (departmentIds) => {
    const postData = {
      departmentIds: departmentIds,
    };
    const response = await genericFetchData(
      "/treatments/byDepartment",
      "POST",
      postData
    );
    const responseData = await response.json();
    if (response.status === 200) {
      setTreatments(responseData.treatments);
    }
  };

  const getLocations = async () => {
    const response = await genericFetchData(`/locations/basic/all`, "GET");
    const responseData = await response.json();
    if (response.status == 200) {
      setLocations(responseData.locations);
    } else {
      console.log("=======error", response.status);
    }
  };

  const getAllDepartments = async () => {
    const response = await genericFetchData(`/departments/all`, "GET");
    const status = response.status;
    const responseData = await response.json();
    if (status == 200) {
      setDepartments(responseData.departments);
    } else {
      console.log("=======error", responseData);
    }
  };

  const getInterDocuments = async (contextId) => {
    try {
      const response = await genericFetchData(
        `/document/all?contextId=${contextId}&context=${HOSPITAL_CONTEXT}&category=${hospital_international_agreement}`,
        "GET"
      );
      const status = response.status;
      const responseData = await response.json();
      if (status === 200) {
        setInterDoc((s) => ({ ...s, document: responseData }));
      } else {
        console.log("=======error", responseData);
      }
    } catch (error) {
      console.log("=======error", error);
    }
  };

  const getHospitallogo = async (contextId) => {
    try {
      const response = await genericFetchData(
        `/document/all?contextId=${contextId}&context=${HOSPITAL_CONTEXT}&category=${hospital_logo}`,
        "GET"
      );
      const status = response.status;
      const responseData = await response.json();
      if (status === 200) {
        setLogo((s) => ({ ...s, document: responseData }));
      } else {
        console.log("=======error", responseData);
      }
    } catch (error) {
      console.log("=======error", error);
    }
  };

  const getInteriorDocuments = async (contextId) => {
    try {
      const response = await genericFetchData(
        `/document/all?contextId=${contextId}&context=${HOSPITAL_CONTEXT}&category=${hospital_interior_image}`,
        "GET"
      );
      const status = response.status;
      const responseData = await response.json();
      if (status === 200) {
        setInteriorImage((s) => ({ ...s, document: responseData }));
      } else {
        console.log("=======error", responseData);
      }
    } catch (error) {
      console.log("=======error", error);
    }
  };

  const getDocuments = async (contextId) => {
    try {
      const response = await genericFetchData(
        `/document/all?contextId=${contextId}&context=${HOSPITAL_CONTEXT}&category=${hospital_document}`,
        "GET"
      );
      const status = response.status;
      const responseData = await response.json();
      if (status === 200) {
        setDoc((s) => ({ ...s, document: responseData }));
      } else {
        console.log("=======error", responseData);
      }
    } catch (error) {
      console.log("=======error", error);
    }
  };

  const getExteriorImages = async (contextId) => {
    try {
      const response = await genericFetchData(
        `/document/all?contextId=${contextId}&context=${HOSPITAL_CONTEXT}&category=${hospital_exterior_image}`,
        "GET"
      );
      const status = response.status;
      const responseData = await response.json();
      if (status === 200) {
        setDoc((s) => ({ ...s, image: responseData }));
      } else {
        console.log("=======error", responseData);
      }
    } catch (error) {
      console.log("=======error", error);
    }
  };

  const saveHospitalDocuments = async (doc, contextId, category) => {
    const data = {
      documents: doc,
      context: HOSPITAL_CONTEXT,
      category: category,
      contextId: contextId,
    };
    try {
      const response = await uploadDocuments(data);
      if (response.status == 200) {
        console.log("Document saved successfully");
      }
    } catch (error) {
      console.log("error===============", error);
    }
  };

  const [duplicateName, setDuplicateName] = useState(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);

  // const checkForDuplicates = () => {
  //   const isDuplicate = duplicateName?.some(
  //     (data) => data.name.toLowerCase() === details.name.toLowerCase()
  //   );
  //   if (isDuplicate) {
  //     console.log("Duplicate found, setting modal to trueee");
  //     setShowDuplicateModal(true);
  //   } else {
  //     console.log("No duplicate found");
  //   }
  // };

  const getDuplicateHospital = async () => {
    const name = details.name;
    try {
      const response = await genericFetchData(
        `/center/checkDuplicate?name=${name}`,
        "GET"
      );
      const status = response.status;
      const responseData = await response.json();
      if (status === 200) {
        console.log(responseData, "checking");
        const nameExist = responseData.some(
          (item) => item.name && item.name === name
        );
        if (nameExist) {
          setDuplicateName(true);
        } else {
          console.log("doesnt exist");
          setDuplicateName(false);
        }
      } else {
        console.log("=======error", responseData);
      }
    } catch (error) {
      console.log("=======error", error);
    }
  };

  const handleDuplicate = () => {
    getDuplicateHospital();
  };

  useEffect(() => {
    getDuplicateHospital();
  }, [details?.name]);

  const saveNewHospital =async (status = null) => {
    if (checkedItemsId.length > 0) {
      const postData = {
        about: details.about,
        address: details.address,
        alternateContactNumber: details.alternateContactNumber,
        contactNumber: details.contactNumber,
        departmentIds: details.departmentIds,
        topTreatmentIds: details.topTreatmentIds,
        email: details.email,
        locationId: details.location?.id,
        mapLink: details.mapLink,
        coordinates: details.coordinates,
        name: details.name,
        platformIds: checkedItemsId.map((value) => Number(value)),
        taskId: taskId,
        referenceLinks: details.referralLink,
         ...(status && { status }),
      };

      if (id) {
        postData.id = id;
      }

      if (!details.name) {
        setIsHospitalNameValid({ ...isHospitalNameValid, isName: true });
        return;
      } else if (!postData.locationId) {
        setIsHospitalNameValid({ ...isHospitalNameValid, isLocation: true });
        return;
      } else if (!details.contactNumber) {
        setIsHospitalNameValid({ ...isHospitalNameValid, isContact: true });
        return;
      } else {
        const response = await genericFetchData(
          `/center/save`,
          "POST",
          postData
        );
        const status = response.status;
        console.log('api called-----------',response)

        const responseData = await response.json();
        if (status === 200) {
          if (doc.hospitalDoc.length) {
            saveHospitalDocuments(
              doc.hospitalDoc.map((val) => val),
              responseData.id,
              hospital_document
            );
          }
          if (doc.hospitalImage.length) {
            saveHospitalDocuments(
              doc.hospitalImage,
              responseData.id,
              hospital_exterior_image
            );
          }
          if (doc.documentIds.length) {
            const deleteResponse = await genericFetchData(
              `/document/delete?documentIds=${doc.documentIds.map((id) => id)}`,
              "DELETE"
            );
            if (deleteResponse == 200) {
              console.log("error=================", deleteResponse.status);
            }
          }
          if (interdoc.agreementDoc.length) {
            saveDocuments(responseData.id);
          }

          if (interiorImage.agreementDoc.length) {
            saveInteriorDocuments(responseData.id);
          }

          if (interiorImage.documentIds.length) {
            const deleteResponse = await genericFetchData(
              `/document/delete?documentIds=${interiorImage.documentIds.map(
                (id) => id
              )}`,
              "DELETE"
            );
            if (deleteResponse == 200) {
              console.log("error=================", deleteResponse.status);
            }
          }

          if (logo.agreementDoc.length) {
            saveHospitalLogo(responseData.id);
          }

          if (logo.documentIds.length) {
            const deleteResponse = await genericFetchData(
              `/document/delete?documentIds=${logo.documentIds.map(
                (id) => id
              )}`,
              "DELETE"
            );
            if (deleteResponse == 200) {
              console.log("error=================", deleteResponse.status);
            }
          }

          if (interdoc.documentIds.length) {
            const deleteResponse = await genericFetchData(
              `/document/delete?documentIds=${interdoc.documentIds.map(
                (id) => id
              )}`,
              "DELETE"
            );
            if (deleteResponse == 200) {
              console.log("error=================", deleteResponse.status);
            }
          }

          console.log(
            "length===========================",
            domDoc.agreementDoc.length
          );
          if (domDoc.agreementDoc.length) {
            saveDomDocuments(responseData.id);
          }
          if (domDoc.documentIds.length) {
            const deleteResponse = await genericFetchData(
              `/document/delete?documentIds=${domDoc.documentIds.map(
                (id) => id
              )}`,
              "DELETE"
            );
            if (deleteResponse == 200) {
              console.log("error=================", deleteResponse.status);
            }
          }
          alert("saved successfully");
          getHospitalDetails(responseData.id);
          getDocuments(responseData.id);
          getInterDocuments(responseData.id);
          getDomDocuments(responseData.id);
          getExteriorImages(responseData.id);
          getInteriorDocuments(responseData.id);
          getHospitallogo(responseData.id);
          navigate("/hospital");
          // navigate("/approvalsPending");
        } else {
          console.log("=======error", responseData);
        }
      }
    } else {
      handleClick({ vertical: "top", horizontal: "center" });
    }
  };

  useEffect(() => {
    if (id) {
      setIsEditable(false);
      getHospitalDetails(id);
      getDocuments(id);
      getInterDocuments(id);
      getDomDocuments(id);
      getExteriorImages(id);
      getInteriorDocuments(id);
      getHospitallogo(id);
    }
    getLocations();
    getAllDepartments();
  }, [department]);

  useEffect(() => {
    switch (department) {
      case "OPERATIONS":
        setActiveTab(0);
        getHospitalDetails(id);
        break;
      case "FINANCE":
        setActiveTab(1);
        getHospitalDetails(id);
        break;
      case "INSURANCE":
        setActiveTab(2);
        break;
      default:
        break;
    }
  }, [department]);
  return {
    details,
    setDetails,
    id,
    checkedItems,
    setCheckedItems,
    locations,
    departments,
    saveNewHospital,
    checkedItemsId,
    items,
    setCheckedItemsId,
    isEditable,
    setIsEditable,
    doc,
    setDoc,
    setIsHospitalValid: setIsHospitalNameValid,
    isHospitalValid: isHospitalNameValid,
    interdoc,
    setInterDoc,
    domDoc,
    setDomDoc,
    logo,
    setLogo,
    interiorImage,
    setInteriorImage,
    treatments,
    getTreatments,
    state,
    isLive,
    setState,
    currentStatus,
    handleDisapprove,
    setRejectedReason,
    locationData,
    rejectedReason,
    setError,
    error,
    locationDatas,
    activeTab,
    handleTabChange,
    getHospitalDetails,
    showDuplicateModal,
    setShowDuplicateModal,
    handleDuplicate,
    duplicateName,
    isShow,
  };
}
